<template></template>

<script>
import { mapGetters } from 'vuex'
import ValidationForm from '../components/ValidationForm.vue';
import ValidationField from '../components/ValidationField.vue';

export default {
    components: { ValidationForm, ValidationField },
    computed: {
        ...mapGetters({
            zones: 'allZones',
            alerts: 'allAlerts',
            devices: 'allDevices',
            notifications: 'allNotifications',
        }),
        extensions_in_use: function() {
            const resources = [
                ...this.zones, 
                ...this.alerts, 
                ...this.devices, 
                ...this.notifications
            ];
            return resources.map(r => r.extension && Number(r.extension));
        }
    }
}
</script>